import { useOurSelectUserEmail } from '@petconsole/pure-fe-state';

const useOurCurrentAdmin = () => {
  const email = useOurSelectUserEmail() as string | undefined;

  return { admin: email?.toLowerCase().endsWith('@petconsole.com') };
};

export default useOurCurrentAdmin;
